(function () {
  'use strict';

  var COLOR_MAP = {
    'WB': '#98c33c',
    'IHC-P': '#ebc138',
    'IHC-F': '#ee644a',
    'IF(IHC-P)': '#2cd4bf',
    'IF(IHC-F)': '#ff62a4',
    'IF(ICC)': '#004aad',
    'ICC': '#004aad',
    'ELISA': '#73caee',
    'LFA': '#a3cd3f',
    'CLIA': '#2b1263',
    'FCM': '#ff3131',
    'IP': '#271264'
  };

  function normalizeApplicationLabel(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, '')
      .replace(/[（]/g, '(')
      .replace(/[）]/g, ')')
      .toUpperCase();
  }

  function colorApplicationPills(root) {
    root = root || document;
    var selector = [
      '.product-details ul.tags li',
      '#product-attributes .dilution-tag span',
      '#product-attributes ul.tags li',
      '.bioss-ivd-card__top strong',
      '.bioss-assay-dilution-table__application',
      '.bioss-pair-overview-application',
      '.bioss-card-application-pill'
    ].join(',');

    var pills = root.querySelectorAll(selector);
    for (var i = 0; i < pills.length; i += 1) {
      var pill = pills[i];
      var label = normalizeApplicationLabel(pill.textContent);
      if (label === 'ICA') {
        pill.textContent = 'LFA';
        pill.setAttribute('data-bioss-source-application', 'ICA');
        label = 'LFA';
      }

      var color = COLOR_MAP[label];
      if (!color) continue;
      pill.style.backgroundColor = color;
      var foreground = ['IF(ICC)', 'ICC', 'CLIA', 'IP'].indexOf(label) !== -1 ? '#ffffff' : '#171322';
      pill.style.setProperty('color', foreground, 'important');
      pill.setAttribute('data-bioss-app-pill-color', color);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { colorApplicationPills(document); });
  } else {
    colorApplicationPills(document);
  }

  window.addEventListener('load', function () { colorApplicationPills(document); });

  if (window.MutationObserver) {
    var scanTimer = null;
    var observer = new MutationObserver(function () {
      if (scanTimer) window.clearTimeout(scanTimer);
      scanTimer = window.setTimeout(function () {
        scanTimer = null;
        colorApplicationPills(document);
      }, 150);
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
